import { createSelector } from 'reselect';
import { RootState } from 'store';

export const getLoyaltyState = (state: RootState) => state.loyalty;

export const getLoyaltyEstimate = createSelector(getLoyaltyState, loyalty => loyalty.estimate);

export const getLoyaltyLoading = createSelector(getLoyaltyState, loyalty => loyalty.loading);

export const getLoyaltyEnabled = createSelector(getLoyaltyEstimate, estimate => estimate.enabled);

export const getLoyaltyPointsToEarn = createSelector(
    getLoyaltyEstimate,
    estimate => estimate.pointsToEarn
);

export const getShowLoyaltyBanner = createSelector(
    getLoyaltyEstimate,
    estimate => estimate.enabled && estimate.pointsToEarn > 0
);
